import { useQuery } from '@tanstack/react-query'
import { GetVendiaTableDetailsDocument } from '@vendia/control-plane-api'

import useControlPlaneApi from './use-control-plane-api'

export const useGetVendiaTableDetails = ({
  uniName,
  nodeName,
  tableKey,
}: {
  uniName?: string
  nodeName?: string
  tableKey?: string
}) => {
  const client = useControlPlaneApi()
  return useQuery({
    queryKey: ['getVendiaTableDetails', uniName, nodeName, tableKey],
    queryFn: async () => {
      return client.graphqlFetch({
        query: GetVendiaTableDetailsDocument,
        variables: { uniName: uniName!, nodeName: nodeName!, tableKey: tableKey! },
      }) as Promise<{
        getVendiaTableDetails: { rowCount: string; lastUpdated: string; totalDataSize: string; tableSchema: any[] }
      }>
    },
    enabled: Boolean(client) && Boolean(uniName) && Boolean(nodeName) && Boolean(tableKey),
  })
}
